export default {
    home: {},
};
